import { defineMessages } from "react-intl";

const messages = defineMessages({
    level: {
        id: "choir.meta.general.level.label",
        defaultMessage: "Level"
    },
    forProject: {
        id: "choir.meta.general.forProject.label",
        defaultMessage: "For project"
    },
    goal: {
        id: "choir.meta.general.goal.label",
        defaultMessage: "Goal"
    },
    description: {
        id: "choir.meta.general.description.label",
        defaultMessage: "Description"
    },
    repertoireNature: {
        id: "choir.meta.general.repertoirNature.label",
        defaultMessage: "Nature of repertoir"
    },
    style: {
        id: "choir.meta.general.style.label",
        defaultMessage: "Style"
    },
    acapella: {
        id: "choir.meta.general.acapella.label",
        defaultMessage: "A capella"
    },
    wayOfSinging: {
        id: "choir.meta.general.wayOfSinging",
        defaultMessage: "Way of singing"
    },
    denomination: {
        id: "choir.meta.general.denomination.label",
        defaultMessage: "Denomination"
    },
    descriptionPlaceholder: {
        id: "choir.meta.general.description.placeholder",
    },
    rehearsalLocation: {
        id: "choir.meta.general.rehearsalLocation.label",
        defaultMessage: "Rehearsal location"
    },
    wantedVoices: {
        id: "choir.meta.general.wantedVoices",
        defaultMessage: "Missing voices"
    },
});

export default messages;
